import { forwardRef, PropsWithChildren, Ref } from 'react';

import { Box } from '@mui/material';

import { BaseProps, OrNull } from '../../types';

const RichTextButton = forwardRef(
  (
    {
      className,
      active,
      reversed,
      ...props
    }: PropsWithChildren<
      {
        active?: boolean;
        reversed?: boolean;
      } & BaseProps
    >,
    ref: Ref<OrNull<HTMLSpanElement>>,
  ) => {
    const color = reversed ? (active ? 'white' : '#aaa') : active ? 'black' : '#ccc';
    return <Box {...props} ref={ref} className={className} sx={{ cursor: 'pointer', color: color }} component="span" />;
  },
);

export default RichTextButton;
